import { useEffect } from "react"
import { Route, Routes } from "react-router-dom"

import "./App.css"

import Main from "./page/Main"
import Inquire from "./page/Inquire/Inquire"
import SignIn from "./page/Sign/SignIn"
import SignUp from "./page/Sign/SignUp"
import ResetPW from "./page/Sign/ResetPW"
import Purchase from "./page/Shop/Purchase"
import Qualification from "./page/Shop/Qualification"
import Examination from "./page/Test/Examination"
import PersonalCode from "./page/Test/PersonalCode"
import PersonalWaiting from "./page/Test/PersonalWaiting"
import PersonalComplete from "./page/Test/PersonalComplete"
import PersonalResult from "./page/Test/PersonalResult"
import GroupCode from "./page/Test/GroupCode"
import GroupWaiting from "./page/Test/GroupWaiting"
import GroupComplete from "./page/Test/GroupComplete"
import GroupResult from "./page/Test/GroupResult"
import WebTestStart from "./page/WebTest/WebTestStart"
import WebTestGuide from "./page/WebTest/WebTestGuide"
import WebTestConduct from "./page/WebTest/WebTestConduct"
import WebTestComplete from "./page/WebTest/WebTestComplete"
import MyPage from "./page/MyPage/MyPage"
import MyModify from "./page/MyPage/MyModify"
import MyOrder from "./page/MyPage/MyOrder"
import TestResult from "./page/Test/TestResult";
import WebTestIntro from "./page/WebTest/WebTestIntro";
import TestResults from "./page/Test/TestResults";

function App() {
	useEffect(() => {
		window.onbeforeunload = function pushRefresh() {
			window.scrollTo(0, 0)
		}
	}, [])

	return (
		<div className="App">
			<Routes>
				<Route path="/" element={<Main />} />
				<Route path="/inquire" element={<Inquire />} />
				<Route path="/sign-in" element={<SignIn />} />
				<Route path="/sign-up" element={<SignUp />} />
				<Route path="/reset-password" element={<ResetPW />} />
				<Route path="/purchase-online" element={<Purchase />} />
				<Route path="/purchase-qualification" element={<Qualification />} />
				<Route path="/online-examination" element={<Examination />} />
				<Route path="/personal-code" element={<PersonalCode />} />
				<Route path="/personal-code/send-waiting" element={<PersonalWaiting />} />
				<Route path="/personal-code/send-complete" element={<PersonalComplete />} />
				<Route path="/personal-result" element={<PersonalResult />} />
				<Route path="/group-code" element={<GroupCode />} />
				<Route path="/group-code/send-waiting" element={<GroupWaiting />} />
				<Route path="/group-code/send-complete" element={<GroupComplete />} />
				<Route path="/group-code/send-waiting/:groupId" element={<GroupWaiting />} />
				<Route path="/group-code/send-complete/:groupId" element={<GroupComplete />} />
				<Route path="/group-result" element={<GroupResult />} />
				<Route path="/start-test" element={<WebTestStart />} />
				<Route path="/start-guide" element={<WebTestGuide />} />
				<Route path="/conduct-test" element={<WebTestConduct />} />
				<Route path="/complete-test" element={<WebTestComplete />} />
				<Route path="/my-page" element={<MyPage />} />
				<Route path="/my-page/modify" element={<MyModify />} />
				<Route path="/my-page/order" element={<MyOrder />} />
				<Route path="/test-result/:id" element={<TestResult />} />
				<Route path="/test-intro" element={<WebTestIntro />} />
				<Route path="/test-results/:ids" element={<TestResults />} />

			</Routes>
		</div>
	)
}

export default App
